import { render, staticRenderFns } from "./ABList.vue?vue&type=template&id=3049d5c6&scoped=true"
import script from "./ABList.vue?vue&type=script&lang=js"
export * from "./ABList.vue?vue&type=script&lang=js"
import style0 from "./ABList.vue?vue&type=style&index=0&id=3049d5c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3049d5c6",
  null
  
)

export default component.exports